const TEXT = {
  BANNER_TEXT: {id: 'myLK.overheader'},
};
export {TEXT};
